import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'ALLINCLUSIVE',
  analyticsName: 'All inclusive',
  queryKey: 'f_allIncl',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const boardCode = hotel?.boardCode;

    if (boardCode === 'AI' || boardCode === 'I') {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.TRUE,
        bucketName: 'allAllInclusive',
      };
    }
    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'allAllInclusive',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
